import Seo from "@/components/feature/Seo";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "@/pages/home/components/Hero";
import FeaturedDeepDives from "@/pages/home/components/FeaturedDeepDives";
import TopicGrid from "@/pages/home/components/TopicGrid";
import TimelineStrip from "@/pages/home/components/TimelineStrip";
import PrinciplesSection from "@/pages/home/components/PrinciplesSection";
import FaqPreview from "@/pages/home/components/FaqPreview";
import SubmitCta from "@/pages/home/components/SubmitCta";
import { articles, featuredSlugs } from "@/mocks/melons";
import { siteBrand } from "@/mocks/site";

const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=Abstract%20dark%20warm%20background%20texture%20with%20deep%20espresso%20and%20brick%20red%20gradient%2C%20a%20soft%20golden%20light%20beam%20crossing%20the%20frame%2C%20layered%20paper%20cutout%20geometric%20shapes%2C%20subtle%20halftone%20grain%2C%20low%20contrast%2C%20cinematic%20depth%2C%20no%20people&width=1600&height=900&seq=shenguashe-hero-01&orientation=landscape";

export default function Home() {
  const featured = featuredSlugs
    .map((slug) => articles.find((item) => item.slug === slug))
    .filter((item): item is (typeof articles)[number] => Boolean(item));

  const origin = typeof window !== "undefined" ? window.location.origin : "https://shenguashe.example.com";

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteBrand.name,
    url: `${origin}${__BASE_PATH__}`,
    description: siteBrand.intro,
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: `${origin}${__BASE_PATH__}topics?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteBrand.name,
    url: `${origin}${__BASE_PATH__}`,
    email: siteBrand.email,
    slogan: siteBrand.slogan,
    description: siteBrand.intro,
    logo: HERO_IMAGE,
  };

  const itemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "本期深度事件复盘",
    itemListElement: featured.map((article, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: `${origin}${__BASE_PATH__}article/${article.slug}`,
      name: article.title,
    })),
  };

  return (
    <>
      <Seo
        title="深瓜社｜热门大瓜深扒·未删减原稿与完整时间线"
        description="深瓜社专注热门大瓜深扒：整理未删减原稿与完整时间线，复盘事件来龙去脉，提供深度解析与冷静吃瓜视角，帮你看懂高潮之前的所有伏笔。"
        keywords="热门大瓜,大瓜深扒,完整时间线,未删减版,深度解析"
        path="/"
        image={HERO_IMAGE}
        jsonLd={[webSiteSchema, organizationSchema, itemListSchema]}
      />
      <SiteHeader />
      <main>
        <Hero />
        <FeaturedDeepDives />
        <TopicGrid />
        <TimelineStrip />
        <PrinciplesSection />
        <FaqPreview />
        <SubmitCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}